





















































































































































































import mixins from 'vue-typed-mixins';
import BookshelfLayoutItem from './BookshelfLayoutItem.vue';
import {
  Bookshelf,
  ResourceItem,
  ResourceLayout,
  ResourceCategory,
  Resource,
} from '@/utils/ResourceUtils';
import { LanguageObject } from '@/i18n';
import { locales } from 'moment';
import cloneDeep from 'lodash.clonedeep';

type ModalType = 'category' | 'resource';

export default mixins().extend({
  components: {
    BookshelfLayoutItem,
  },

  props: {
    value: {
      type: Object as () => Partial<Bookshelf>,
    },

    resources: {
      type: Array as () => Resource[],
    },
  },

  computed: {
    urls() {
      return this.resources?.map((resource) => resource.url);
    },

    languages() {
      return [
        { text: this.$tc(`model.bookshelf.layout.language.any`), value: 'any' },
        ...this.$locales?.map((locale) => ({
          text: this.$tc(`app.label.locale.${locale}`),
          value: locale,
        })),
      ];
    },
  },

  data(): {
    modal?: {
      type?: ModalType;
      parent?: ResourceLayout;
      pristine?: Partial<ResourceLayout>;
      item: Partial<ResourceLayout>;
    };
  } {
    return {
      modal: undefined,
    };
  },

  watch: {
    'modal.type'(type: ModalType) {
      if (this.modal && type) {
        if (
          type === 'category' &&
          !(this.modal.item as ResourceCategory).children
        ) {
          this.modal.item = {
            title: this.$languageobj(),
            children: [],
            options: {
              collapsed: false,
            },
          } as ResourceCategory;
        } else if (
          type === 'resource' &&
          !(this.modal.item as ResourceItem).type
        ) {
          this.modal.item = {
            type: 'url',
            title: this.$languageobj(),
            description: this.$languageobj(),
            value: '',
            language: 'any',
          } as ResourceItem;
        }
      }
    },

    'modal.item.type'(
      type: ResourceItem['type'],
      previous: ResourceItem['type']
    ) {
      if (type && previous && this.modal?.item) {
        (this.modal.item as ResourceItem).value = undefined;
      }
    },
  },

  methods: {
    create(parent?: ResourceLayout) {
      this.modal = {
        type: 'resource',
        parent: parent,
        pristine: undefined,
        item: {},
      };
    },

    edit(item: ResourceLayout, parent?: ResourceLayout) {
      this.modal = {
        type: (item as ResourceCategory).children ? 'category' : 'resource',
        parent: parent,
        pristine: item,
        item: cloneDeep(item),
      };
    },

    async save() {
      /**
       * setTimeout required because of a bug with the department v-combobox
       * https://github.com/vuetifyjs/vuetify/issues/4679
       * The combobox only updates the v-model value on the blur event (when the text field is clicked away from).
       * This doesn't trigger before this submit event is fired if the submit button is clicked immediately.
       * setTimeout gives enough time for the blur event to fire before the submit actually happens.
       */
      setTimeout(() => {
        if (this.modal?.parent) {
          const parent = this.modal.parent as ResourceCategory;
          parent.children = parent.children || [];
          const index = parent.children.findIndex(
            (item) => item === this.modal?.pristine
          );
          if (index >= 0) {
            parent.children[index] = this.modal.item as ResourceLayout;
          } else {
            parent.children.push(this.modal.item as ResourceLayout);
          }
          parent.children = Array.from(parent.children);
        } else if (this.modal) {
          this.value.layout = this.value.layout || [];
          const index = this.value.layout.findIndex(
            (item) => item === this.modal?.pristine
          );
          if (index >= 0) {
            this.value.layout[index] = this.modal.item as ResourceLayout;
          } else {
            this.value.layout.push(this.modal.item as ResourceLayout);
          }
          this.value.layout = Array.from(this.value.layout);
        }

        this.exit();
      }, 100);
    },

    async remove(index: number) {
      if (this.value.layout) {
        await this.$confirm(
          this.$i18n.tc('validation.confirmation.delete', 1, [
            this.$translate(this.value.layout[index].title),
          ]),
          async () => {
            this.value.layout?.splice(index, 1);
          }
        );
      }
    },

    exit() {
      this.modal = undefined;
    },
  },
});
